<template>
    <v-container fluid grid-list-md>
        <v-layout column wrap>
            <v-flex>
                <h1 class="display-3">Gestión de precios</h1>
                <br>
                <v-card>
                    <v-card-text>
                        <form @submit.prevent="agregar()" ref="form" lazy-validation>
                            <v-layout>
                                <v-flex xs12 sm2>
                                    <ubicacion-select label="Origen" v-model="d.origen"></ubicacion-select>
                                </v-flex>
                                <v-flex xs12 sm2>
                                    <provincia-select v-model="d.provincia_id"></provincia-select>
                                </v-flex>
<!--                                <v-flex xs12 sm2>-->
<!--                                    <v-text-field label="Localidad" v-model="d.localidad"></v-text-field>-->
<!--                                </v-flex>-->
                                <v-flex xs12 sm2>
                                    <v-text-field label="Precio" v-model="d.precio"></v-text-field>
                                </v-flex>
                                <v-flex>
                                    <v-flex>
                                        <v-btn type="submit" dark color="green" :loading="loading">
                                            Agregar
                                        </v-btn>
                                    </v-flex>
                                </v-flex>
                            </v-layout>
                        </form>
                        <v-btn dark color="orange" @click="fileSel" :loading="importando">
                            Importar
                        </v-btn>
                        <input
                                @change="onFileSelChange($event)"
                                name="image"
                                ref="fileSel"
                                style="display: none"
                                type="file"
                        />
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        :pagination.sync="pag"
                        :total-items="totalItems"
                        :loading="loading"
                        rows-per-page-text="Filas por pagina"
                        no-data-text="No hay datos"
                        disable-initial-sort
                        item-key="id"
                        class="tabla-compacta-col"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">{{ props.item.origen }}</td>
                        <td class="text-xs-center">{{ (props.item.provincia_id)? props.item.provincia.desig : '' }}</td>
<!--                        <td class="text-xs-center">{{ props.item.localidad }}</td>-->
                        <td class="text-xs-right">
                            <v-edit-dialog
                                    save-text="Guardar"
                                    cancel-text="Cancelar"
                                    large
                                    lazy
                                    style="width: 100%"
                                    @save="editar(props.item)">
                                <span style="width: 100%">{{ (props.item.precio)?props.item.precio : 0 | moneda }}</span>
                                <v-text-field
                                        slot="input"
                                        v-model="precioNuevo"
                                        label="Editar"
                                        single-line
                                        type="number"
                                        hint="Presione <kbd>enter</kbd> para guardar"
                                >
                                </v-text-field>
                            </v-edit-dialog>
                        </td>
                        <td class="text-xs-center">
                            <v-btn flat icon @click.native="eliminar(props.item.id)" color="red" :loading="loadingDel === props.item.id">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import provinciaSelect from '../../components/ProvinciaSelect';
    import ubicacionSelect from '../../components/UbicacionSelect';
    import fleteMixin from '../../mixins/flete_precio';
    import moneda from '../../filters/moneda';
    import {mapActions} from 'vuex';

    function initialValue() {
        return {
            provincia_id: '',
            localidad: '',
            origen: '',
            precio: ''
        }
    }

    export default {
        name: "flete_precio",
        mixins: [fleteMixin],
        filters: {moneda},
        components: {provinciaSelect, ubicacionSelect},
        data() {
            return {
                importando: false,
                loading: false,
                loadingDel: -1,
                d: initialValue(),
                precioNuevo: 0,
                headers: [
                    {text: 'Origen', value: 'origen', align: 'center'},
                    {text: 'Provincia', value: 'provincia_id', align: 'center'},
                    // {text: 'Localidad', value: 'localidad', align: 'center'},
                    {text: 'Precio', value: 'precio', align: 'center'},
                    {text: 'Opciones', value: '', align: 'center', sortable: false},
                ],
                items: [],
                pag: {},
                totalItems: 0,
            }
        },
        watch: {
            pag: {
                handler() {
                    this.tabla();
                },
                deep: true
            }
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            fileSel() {
                this.$refs.fileSel.click();
            },
            onFileSelChange(e) {
                this.importando = true;
                let file = e.target.files[0];
                let fd = new FormData();
                fd.append('file', file);
                this.fletePrecioImportar(fd, r => {
                    this.msjShow(r);
                    this.importando = false;
                }, err => {
                    this.msjShow({tipo: 2, txt: 'Error en procesamiento de datos'});
                    this.importando = false;
                })
            },
            tabla() {
                this.loading = true;
                this.fletePrecioIndex(this.pag, r => {
                    this.totalItems = r.total;
                    this.items = r.data;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                });
            },
            agregar() {
                this.loading = true;
                this.fletePrecioStore(this.d, r => {
                    this.msjShow(r);
                    this.tabla();
                    this.d = initialValue();
                    this.loading = false;
                }, err => {
                    this.msjShow({txt: 'Error al guardar', tipo: 'error'});
                    this.loading = false;
                });
            },
            editar(item) {
                this.loading = true;
                this.fletePrecioUpdate(item.id, {precio: this.precioNuevo}, r => {
                    this.msjShow(r);
                    item.precio = this.precioNuevo;
                    this.precioNuevo = '';
                    this.loading = false;
                }, err => {
                    console.error('Error');
                    this.loading = false;
                });
                return false;
            },
            eliminar(id) {
                this.loadingDel = id;
                this.fletePrecioDestroy(id, r => {
                    this.msjShow(r);
                    this.tabla();
                    this.loadingDel = -1;
                }, err => {
                    this.msjShow({txt: 'Error al eliminar', tipo: 'error'});
                    this.loadingDel = -1;
                });
            },
        }
    }
</script>

<style>
    .v-menu__activator a {
        width: 100% !important;
        text-align: right !important;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/flete/precio.vue